export const APP_LOADING_DELAY_IN_MS = 300;
export const TOKEN_CHANGE_ERROR_MESSAGE_DELAY_IN_MS = 1000;
export const TEXT_FIELD_MAX_LENGTH = 250;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 12;
export const USERNAME_MAX_LENGTH = 250;
export const CHAT_NAME_MAX_LENGTH = 20;
export const MAX_COUNTIES_NAME_LENGTH = 100;

export const DEFAULT_DUE_DAYS_PERIOD = 10;

export const INDICATORS_UPDATE_PERIOD = 10000;
export const INVOICE_INDICATORS_UPDATE_PERIOD = 60000;
export const UPDATE_DRIVER_POSITION_INTERVAL_IN_MS = 15000;

export const AUTOCOMPLETE_TYPING_DELAY_IN_MS = 300;
export const AUTOCOMPLETE_MAX_NUMBER_OF_ITEMS = 15;
export const CHAT_INFO_RELOAD_INTERVAL_IN_SECONDS = 10;

export const MESSAGE_PER_PAGE_IN_CHATS = 20;

export const hiddenChatNames = ["off-topic", "town-square"];

export const localStorageNameEnum = {
  AUTH_TOKEN: "AUTH_TOKEN",
  AUTH_REFRESH_TOKEN: "AUTH_REFRESH_TOKEN",
  COOKIES_ARE_CONFIRMED: "COOKIES_ARE_CONFIRMED",
};

export const DEFAULT_LAT_FOR_PLACE_SEARCH = 32.779167;
export const DEFAULT_LON_FOR_PLACE_SEARCH = -96.808891;

export const states = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FM: "Federated States Of Micronesia",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MH: "Marshall Islands",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  MP: "Northern Mariana Islands",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PW: "Palau",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VI: "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};
